export const extractNumberFromInput = input => {
    let inputValue = input.value;
    const inputValueAsFloat = parseFloat(inputValue);
    if (inputValueAsFloat || inputValueAsFloat === 0) {
        return inputValueAsFloat;
    }
    else {
        return inputValue;
    }
}